import { Col } from "reactstrap";
import { H5 } from "../../../../../AbstractElements";

const Email = localStorage.emailId || "";
const UserType = localStorage.UserType || "";
const Role = localStorage.Role || "";
const FirstName = localStorage.FirstName || "";
const LastName = localStorage.LastName || "";

const ProfileMail = () => {
  const profileFields = [
    { label: "E-mail", value: Email, icon: "fa-envelope" },
    { label: "UserType", value: UserType },
    { label: "Role", value: Role },
    { label: "FirstName", value: FirstName },
    { label: "LastName", value: LastName },
  ];

  return (
    <Col sm={12} xl={4} className="order-sm-1 order-xl-0">
      <div className="profile-info">
        {profileFields.map((field, index) => (
          <div key={index} className="ttl-info text-start mb-3">
            <H5>
              {field.icon && <i className={`fa ${field.icon}`} />}
              {field.icon && <>&nbsp;</>}
              {field.label} : {field.value || <span className="text-muted">N/A</span>}
            </H5>
          </div>
        ))}
      </div>
    </Col>
  );
};

export default ProfileMail;
